export default "__VITE_ASSET__BgHSlExj__"